import './speaker.html.twig';
import './speaker.scss';
import ResizeObserver from 'resize-observer-polyfill';

export default function speaker() {
  const bios = document.querySelectorAll('.speaker__biography');

  if (!bios) {
    return;
  }

  // Observer for the speaker biography content area.
  const observer = new ResizeObserver((entries, observer) => {
    for (const entry of entries) {
      // Sometimes the contentRect height is tenths of a pixel smaller than the scrollHeight.
      // This episilon value is used to require a scrollheight signficantly taller than the contentHeight in size before showing the 'show more'
      // button.
      const epsilon = 4;
      entry.target.classList[
        entry.target.scrollHeight > entry.contentRect.height + epsilon ? 'add' : 'remove'
      ]('speaker__biography-content--truncated');
    }
  });

  // Array.from for IE support
  Array.from(bios).forEach((bio) => {
    // Based on https://paulbakaus.com/tutorials/css/multiline-truncated-text-with-show-more-button-with-just-css/

    // Watch for changes to biography content size
    const content = bio.querySelector('.speaker__biography-content');
    if (!content) {
      return;
    }
    observer.observe(content);

    // Make show more button expand the content.
    const showMore = bio.querySelector('.speaker__biography-show-more');
    if (!showMore) {
      return;
    }
    showMore.addEventListener('click', (e) => {
      e.preventDefault();
      if (!content) {
        return;
      }
      // Disable webkit line clamping. Full text will be visible.
      content.setAttribute('style', '-webkit-line-clamp: unset');
    });
  });
}
